import React from 'react';
import { Outlet } from 'react-router-dom';
import DashNav from './DashNav';

/**
 * Persistent layout for all logged-in dashboard pages.
 *
 * DashNav mounts once when the user enters the dashboard and stays mounted
 * across route changes. This is what prevents its API calls (announcement
 * banner + unread dot) from firing on every page navigation.
 */
export default function DashboardLayout() {
  return (
    <>
      <DashNav />
      <Outlet />
    </>
  );
}
